<template>
  <div class="skeleton"></div>
</template>

<style lang="scss" scoped>
.skeleton {
  @apply tw-bg-gray-200;
  @apply tw-animate-pulse;
}
</style>
